"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var hotelRouter = {
  path: '/hotel',
  component: _layout.default,
  redirect: '/hotel/list',
  name: 'hotel',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/index'));
      });
    },
    name: 'HotelList',
    meta: {
      title: '商品列表',
      icon: ''
    }
  }, {
    path: 'room-type',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/room-type'));
      });
    },
    name: 'roomTypeList',
    meta: {
      title: '房型管理',
      icon: ''
    }
  }, {
    path: 'room-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/room-list'));
      });
    },
    name: 'roomList',
    meta: {
      title: '房间列表',
      icon: ''
    }
  }, {
    path: 'business-view',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/business-view'));
      });
    },
    name: 'businessList',
    meta: {
      title: '经营面板',
      icon: ''
    }
  }, {
    path: 'reservation-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/reservation-list'));
      });
    },
    name: 'reservationList',
    meta: {
      title: '预约列表',
      icon: ''
    }
  }, {
    path: 'cdkey',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/cdkey/index'));
      });
    },
    name: 'Cdkey',
    meta: {
      title: '卡密管理',
      icon: ''
    }
  }, {
    //id:卡密库id
    path: 'cdkey/creatCdkey/:id?/:name?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/cdkey/creatCdkey'));
      });
    },
    name: 'creatCdkey',
    meta: {
      title: '卡密添加',
      noCache: true,
      activeMenu: "/hotel/cdkey"
    },
    hidden: true
  }, {
    path: 'classify',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/category/index'));
      });
    },
    name: 'HotelClassify',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/attr/index'));
      });
    },
    name: 'HotelAttr',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/comment/index'));
      });
    },
    name: 'HotelComment',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是),productType:商品类型
    path: 'list/creatProduct/:id?/:isDisabled/:isCopy/:productType?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/creatProduct/index'));
      });
    },
    name: 'creatHotel',
    meta: {
      title: '房型添加',
      noCache: true,
      activeMenu: "/hotel/room-type"
    },
    hidden: true
  }, {
    path: 'guarantee/group',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/guarantee/index'));
      });
    },
    name: 'HotelGuarantee',
    meta: {
      title: '保障服务组合',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/hotel/label/index'));
      });
    },
    name: 'HotelLabel',
    meta: {
      title: '商品标签',
      icon: ''
    }
  }]
};
var _default = exports.default = hotelRouter;